import { Component, Inject } from '@angular/core';
import { ISitemap, SITEMAP } from 'pbc.angular';
import { IFilterConfig, ISelection } from 'pbc.types';

import get from 'lodash/get';
import { Subscription } from 'rxjs';

import { IRechnungsVorlagenQueryShapes, IRechnungsVorlagenResponse, RechnungsVorlagenQueryFilterConfig } from 'fa-kt.types';
import { RechnungsVorlagenService } from '../service';

@Component({
  selector: 'fa-kt-rechnungs-vorlagen-filter',
  templateUrl: './rechnungs-vorlagen-filter.component.html',
  styleUrls: ['./rechnungs-vorlagen-filter.component.css'],
})
export class RechnungsVorlagenFilterComponent {
  readonly subscriptions: Subscription[] = [];

  public RechnungsVorlagenFilterConfig: IFilterConfig<IRechnungsVorlagenResponse>;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public rechnungsVorlagen: RechnungsVorlagenService,
  ) {
    this.RechnungsVorlagenFilterConfig = RechnungsVorlagenQueryFilterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update mapper    */
    /*    update mapper >> */
  }

  ngOnInit() {
    this.subscriptions.push(
      this.rechnungsVorlagen.shapes$.subscribe((shapes: IRechnungsVorlagenQueryShapes | undefined) => {
        if (!shapes) {
          return;
        }
        Object.entries(shapes)
          .filter(([key]) => key !== 'id' && (shapes as any)[key])
          .forEach(([key]) => this.shape(key, (shapes as any)[key]));
      }),
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(($) => $.unsubscribe());
  }

  private shape(field: string, shapes: ISelection[]): void {
    const index = this.RechnungsVorlagenFilterConfig.findIndex((f) => f.key === field);
    if (index < 0) {
      return;
    }
    this.RechnungsVorlagenFilterConfig[index].selections = shapes;
  }
}
